import BannerComp from "../../../components/BannerComp";
import FeatureImageContent from "../../../components/FeatureImageContent";
import ImageTextSection from "../../../components/ImageTextSection";
import ProPrograms from "../../../components/ProPrograms";
import Seo from "../../../components/Seo";
import { proProgramsData } from "../../../data/brainzeropro";
import { createBreadcrumbSchema, createWebPageSchema } from "../../../lib/seo";
import section1Image from "./brainzen_section1.webp";
import section2Image from "./brainzen_section2.webp";
import section3Image from "./brainzen_section3.webp";

const seo = {
  title: "Brain Zen Pro | MIT4Doctors",
  description:
    "Change the game in mental health and brain fitness with Brain Zen Pro. Our neurofeedback technology offers unmatched precision and success.",
  schema: [
    createWebPageSchema({
      path: "/services/brain-zen-pro",
      title: "Brain Zen Pro",
      description:
        "Get ready to change the game in mental health and brain fitness with Brain Zen Pro. Our excellent neurofeedback technology offers unmatched precision and success.",
    }),
    createBreadcrumbSchema("/services/brain-zen-pro", "Brain Zen Pro"),
  ],
};

export default function BrainZenPro() {
  return (
    <>
      <Seo
        title={seo.title}
        metaTitle={seo.title}
        description={seo.description}
        canonicalPath="/services/brain-zen-pro"
        schema={seo.schema}
      />
      <BannerComp
        heading="Brain Zen Pro"
        paragraph="Get ready to change the game in mental health and brain fitness with Brain Zen Pro. Our excellent neurofeedback technology offers unmatched precision and success."
        centered
        BannerBgImg="/img/banners/brainzenpro_hero.webp"
      />
      <ImageTextSection
        image={section1Image}
        imageAlt="What Is Brain Zen Pro?"
        imagePosition="left"
        title="What Is Brain Zen Pro?"
        description="Brain Zen Pro is a neurofeedback program from Medical Imaging Technology. It uses real-time brain activity monitoring to help regulate brain function. It's an effective, evidence-based treatment for ADHD, PTSD, autism, behavioral disorders, and addiction. Brain Zen Pro uses the brain's natural self-regulation. It offers a safe, non-invasive, medication-free treatment for patients aged 5 and up."
        highlightWords="Zen Pro?"
      />

      <ProPrograms
        heading="What Sets Brain Zen"
        highlightText="Pro Apart?"
        description="Brain Zen Pro uses advanced EEG technology. It offers personalized, low-cost treatments with no advance fees. MITSI ensures continuous integration, providing full support and training for your practice."
        programs={proProgramsData}
      />

      <FeatureImageContent
        heading="Your Practice Growth Matters to Us"
        description="We offer innovative solutions, like neurofeedback therapy. Our approach improves patient care, increases satisfaction, and enhances revenue. It ensures your practice's long-term success."
        buttonLabel="Get Started"
        buttonUrl="/contact-us"
        imageAlt="Your Practice Growth Matters to Us"
      />

      <ImageTextSection
        image={section2Image}
        imageAlt="Brain Zen Pro Main Benefits for Patients"
        imagePosition="left"
        title="Brain Zen Pro Main Benefits for Patients"
        highlightWords="Patients"
        subSections={[
          {
            listItems: [
              "Lasting Results: Most patients need fewer sessions after treatment.",
              "Safe & Non-Invasive: No medications or invasive procedures are involved.",
              "Complementary Care: Works well with other treatments for comprehensive care.",
              "Affordable Access: Covered by Medicare, Medicaid, and top private insurance.",
            ],
            listItemBoldText: [
              "Lasting Results",
              "Safe & Non-Invasive",
              "Complementary Care",
              "Affordable Access",
            ],
          },
        ]}
      />

      <ImageTextSection
        image={section3Image}
        imageAlt="Experience Brain Zen Pro"
        imagePosition="right"
        title="Experience Brain Zen Pro"
        description="Enable your practice to deliver first-class neurofeedback therapy. Give your patients the benefits of advanced neurofeedback therapy. It will improve patient outcomes and increase revenue. Contact Medical Imaging Technology. Learn how Brain Zen Pro can help your patients and your practice."
        highlightWords="Zen Pro"
      />
    </>
  );
}
